import React from "react"

import {Col, Row} from "react-bootstrap"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Hr from "@irati/ui/src/Layout/Hr"
import {CheckoutRedemptionOrder} from "@irati/types"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import Total from "../../OrderSummary/Total"
import Subtotal from "../../OrderSummary/Subtotal"

interface Props extends WithPerkOrReward {
  order: CheckoutRedemptionOrder
}

const OrderDetails: React.FC<Props> = ({order, isRewards}) => {
  const totals = order.totals
  const currency = order.totals.total.currency

  if (isRewards) {
    return (
      <>
        <Hr />
        <Total isCents paid total={order.basket.total.amount} currency={order.basket.total.currency} />
      </>
    )
  }

  return (
    <div>
      <Hr />
      <Subtotal
        subtotal={totals.totalBeforeDiscount.value}
        discount={totals.totalBeforeDiscount.value - totals.total.value}
        padSubtotal
        isCents={false}
        currency={currency}
      />
      <Row>
        <Col xs={10}>
          <FormattedMessage id="perks.components.dealSuccessOrderSummary.orderDetails.vat" />
        </Col>
        <Col xs={2}>
          <div className="pull-right">
            <FormattedCurrency isCents={false} currency={currency} value={totals.totalVAT.value} />
          </div>
        </Col>
      </Row>
      <Hr />
      <Total isCents={false} paid total={totals.total.value} currency={currency} />
    </div>
  )
}

export default withPerkOrReward(OrderDetails)
